import EventConfiguration from '@/types/EventConfiguration'
import { http } from '../plugins/http'
import { AxiosResponse } from 'axios'
import PaginatedResponse from '@/types/PaginatedResponse'
import DataResponse from '@/types/DataResponse'

export default class EventConfigurationService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<EventConfiguration>>> {
    return await http.get<PaginatedResponse<EventConfiguration>>(`/api/v1/office/event-configurations?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<EventConfiguration>>(`/api/v1/office/event-configurations/${id}`)
  }

  async store(payload: EventConfiguration) {
    const headers = { 'Content-Type': 'multipart/form-data' }

    // https://laravel.com/docs/11.x/routing#form-method-spoofing
    // @ts-expect-error applying method spoofing on object
    payload._method = 'post'

    return await http.post<EventConfiguration>(`/api/v1/office/event-configurations`, payload, { headers })
  }

  async update(payload: EventConfiguration) {
    return await http.put<EventConfiguration>(`/api/v1/office/event-configurations/${payload.id}`, payload)
  }

  async destroy(payload: EventConfiguration) {
    return await http.delete<EventConfiguration>(`/api/v1/office/event-configurations/${payload.id}`)
  }
}
